import { adminHttpClient } from '../../commons/adminHttpClient'
import PagedFilter from 'application/commons/pagedFilter'
import PagedList from 'application/commons/pagedList'

export type PagedDefaultExpenseTypes = PagedList<DefaultExpenseTypeResponse>

export type DefaultExpenseFilter = PagedFilter & {
  productId: number
  categoryId?: number
  q?: string
}

export interface DefaultExpenseTypeResponse {
  id: number
  name: string
  Code: string
  active: boolean
  limitedHraEligible: boolean
  aiAutoVerifyEnabled: boolean
}

const getDefaultExpenseTypes = (filter: DefaultExpenseFilter): Promise<PagedDefaultExpenseTypes> =>
  adminHttpClient.get('Expenses/DefaultExpenseTypes', filter)

export default getDefaultExpenseTypes
